import { useQuery } from '@tanstack/react-query'
import * as endPoints from '@/endpoints'
import axios from '@/lib/axios'

// The backend endpoint is active-org scoped, so the query is keyed by the org it will
// actually answer for — same convention as useSetupStatus's setupStatusKey.
export const onboardingPlanKey = (orgId) => ['onboarding', 'plan', orgId]

// GET /api/onboarding/current/plan/ (org-onboarding-hub task 3.3) has not landed yet at
// the time this hook was written — it is being built in a later wave. Consumers (e.g.
// SetupReturnBanner) must treat `data` as possibly undefined indefinitely, not just
// during a loading flash: retry is disabled so a 404/network error resolves once and
// stays quiet rather than retry-storming or ever throwing, and there is no error toast
// here (this repo has no global query-error toast, so simply not adding one is enough).
const useOnboardingPlan = (orgId, { enabled = true } = {}) =>
    useQuery({
        queryKey: onboardingPlanKey(orgId),
        queryFn: () =>
            axios.get(endPoints.ONBOARDING_CURRENT_PLAN).then((r) => r.data),
        enabled: Boolean(orgId) && enabled,
        retry: false
    })

export default useOnboardingPlan
